@if (shouldShow) {
<div class="app-gate">
    <div class="app-gate__content">
        <div class="app-gate__logo">
            <img src="assets/images/icons/app-icon.webp" alt="My Workplace" />
        </div>

        <h1 class="app-gate__title">
            The best experience is on the app!
        </h1>

        <button class="app-gate__primary" (click)="getApp()">
            @if(isIos) {
            <ng-container>
                <img src="assets/images/icons/apple_logo_black.svg" class="app-gate__icon" alt="" />
            </ng-container>
            }
            Get the app
        </button>
        <div class="app-gate__secondary">
            Already have an account?

        </div>
        <button class="app-gate__primary" (click)="dismiss()">
            Sign in
        </button>
    </div>
</div>
}